import { ResponsiveContainer } from '@arpeggi/ui'
import { FC, useEffect, useRef, useState } from 'react'
import Header from './components/Header'
import SamplePacksTable from './components/SamplePacksTable'
import { SongsTable, SoundsTable } from './components/Table'
import Tabs from './components/Tabs'
import useExploreTabs from './hooks/useExploreTabs'
import { SearchContext } from './hooks/useSearch'

const Explore: FC = () => {
  const { tab, handleChange } = useExploreTabs()
  const [search, setSearch] = useState<string>('')
  const [isSticky, setIsSticky] = useState(false)
  const ref = useRef<HTMLDivElement>()
  const headerRef = useRef<HTMLDivElement>()

  useEffect(() => {
    const handleScroll = () => {
      if (ref.current?.offsetTop < window.scrollY) {
        setIsSticky(true)
      } else {
        setIsSticky(false)
      }
    }

    window.addEventListener('scroll', handleScroll)

    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <SearchContext.Provider value={[search, setSearch]}>
      <Tabs.Root ref={ref} defaultValue="songs" onValueChange={handleChange} value={tab}>
        <ResponsiveContainer>
          <Header ref={headerRef} />
          <Tabs.Content value="songs">
            <SongsTable top={(headerRef.current?.clientHeight || 0) + 'px'} />
          </Tabs.Content>
          <Tabs.Content value="sounds">
            <SoundsTable top={(headerRef.current?.clientHeight || 0) + 'px'} />
          </Tabs.Content>
          <Tabs.Content value="packs">
            <SamplePacksTable />
          </Tabs.Content>
        </ResponsiveContainer>
      </Tabs.Root>
    </SearchContext.Provider>
  )
}

export default Explore
